import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Form, Button, Alert, Spinner, Row, Col } from 'react-bootstrap';
import { academyStore } from '../stores/AcademyStore';
const AcademyDialog = observer(() => {
    const [formData, setFormData] = useState({
        name: '',
        city: '',
        phoneNumber: '',
        emailId: ''
    });
    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (academyStore.isDialogOpen && academyStore.selectedAcademy) {
            setFormData({
                name: academyStore.selectedAcademy.name,
                city: academyStore.selectedAcademy.city || '',
                phoneNumber: academyStore.selectedAcademy.phoneNumber || '',
                emailId: academyStore.selectedAcademy.emailId || ''
            });
        }
        else if (academyStore.isDialogOpen && !academyStore.selectedAcademy) {
            setFormData({
                name: '',
                city: '',
                phoneNumber: '',
                emailId: ''
            });
        }
    }, [academyStore.isDialogOpen, academyStore.selectedAcademy]);
    const handleInputChange = (field) => (event) => {
        setFormData(prev => ({
            ...prev,
            [field]: event.target.value
        }));
        // Clear error when user starts typing
        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: undefined
            }));
        }
    };
    const validateForm = () => {
        const newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = 'Academy name is required';
        }
        if (formData.emailId && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
            newErrors.emailId = 'Please enter a valid email address';
        }
        if (formData.phoneNumber && !/^[\+]?[1-9][\d]{0,15}$/.test(formData.phoneNumber)) {
            newErrors.phoneNumber = 'Please enter a valid phone number';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm())
            return;
        try {
            if (academyStore.isEditing && academyStore.selectedAcademy) {
                await academyStore.updateAcademy(academyStore.selectedAcademy.id, formData);
            }
            else {
                await academyStore.createAcademy(formData);
            }
            academyStore.closeDialog();
        }
        catch (error) {
            // Error is handled by the store
        }
    };
    const handleClose = () => {
        academyStore.closeDialog();
        setErrors({});
    };
    return (_jsxs(Modal, { show: academyStore.isDialogOpen, onHide: handleClose, size: "lg", children: [_jsx(Modal.Header, { closeButton: true, children: _jsx(Modal.Title, { children: academyStore.isEditing ? 'Edit Academy' : 'Add New Academy' }) }), _jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs(Modal.Body, { children: [academyStore.hasError && (_jsx(Alert, { variant: "danger", children: academyStore.error })), _jsxs(Row, { children: [_jsx(Col, { xs: 12, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Academy Name *" }), _jsx(Form.Control, { type: "text", value: formData.name, onChange: handleInputChange('name'), isInvalid: !!errors.name, disabled: academyStore.isLoading }), _jsx(Form.Control.Feedback, { type: "invalid", children: errors.name })] }) }), _jsx(Col, { xs: 12, md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "City" }), _jsx(Form.Control, { type: "text", value: formData.city, onChange: handleInputChange('city'), isInvalid: !!errors.city, disabled: academyStore.isLoading }), _jsx(Form.Control.Feedback, { type: "invalid", children: errors.city })] }) }), _jsx(Col, { xs: 12, md: 6, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Phone Number" }), _jsx(Form.Control, { type: "tel", value: formData.phoneNumber, onChange: handleInputChange('phoneNumber'), isInvalid: !!errors.phoneNumber, disabled: academyStore.isLoading }), _jsx(Form.Control.Feedback, { type: "invalid", children: errors.phoneNumber })] }) }), _jsx(Col, { xs: 12, children: _jsxs(Form.Group, { className: "mb-3", children: [_jsx(Form.Label, { children: "Email" }), _jsx(Form.Control, { type: "email", value: formData.emailId, onChange: handleInputChange('emailId'), isInvalid: !!errors.emailId, disabled: academyStore.isLoading }), _jsx(Form.Control.Feedback, { type: "invalid", children: errors.emailId })] }) })] })] }), _jsxs(Modal.Footer, { children: [_jsx(Button, { variant: "secondary", onClick: handleClose, disabled: academyStore.isLoading, className: "btn-touch w-mobile-100", children: "Cancel" }), _jsxs(Button, { type: "submit", variant: "primary", disabled: academyStore.isLoading, className: "btn-touch w-mobile-100", children: [academyStore.isLoading && _jsx(Spinner, { animation: "border", size: "sm", className: "me-2" }), academyStore.isEditing ? 'Update' : 'Create'] })] })] })] }));
});
export default AcademyDialog;
